import { render, staticRenderFns } from "./stand.vue?vue&type=template&id=fa930a00"
import script from "./stand.vue?vue&type=script&lang=js"
export * from "./stand.vue?vue&type=script&lang=js"
import style0 from "./stand.vue?vue&type=style&index=0&id=fa930a00&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports